import React, { useEffect, useState } from "react";
import * as Icons from "@phosphor-icons/react";

const DynamicIcon = ({ iconName, size }) => {
  const [IconComponent, setIconComponent] = useState(null);

  useEffect(() => {
    const importIcon = async () => {
      const icon = Icons[iconName];
      if (icon) {
        setIconComponent(() => icon);
      }
    };

    importIcon();
  }, [iconName]);

  if (!IconComponent) {
    return null; // Or render a placeholder/loading state if desired
  }

  return <IconComponent size={size} />;
};

export default DynamicIcon;
